<template>
  <div class="table-row project-tenders-columns">
    <div class="tender-row text-sm">
      <div class="grey-900 truncate">{{ tender.name }}</div>
      <div class="grey-500">{{ prettyDates(tender.offers_deadline_date) }}</div>
    </div>
    <div class="tender-row"><UserInfo :user="tender.contact_person_responsible_user" /></div>
    <div class="tender-row spacey-4">
      <Badge color="light-blue">
        {{ $tc('offer', tender.offers.length) }}
      </Badge>
      <div class="grey-500 text-sm">
        {{ tender.offers_count }}
        {{ tender.offers_count === 1 ? $t('company') : $t('companies') }}
      </div>
    </div>
    <div class="tender-row">
      <span v-if="tender.files.length">
        <button class="primary-600 link" @click="$emit('show-files')">
          <AttachIcon class="primary-icon" />
          {{ $tc('file', tender.files.length) }}
        </button>
      </span>
      <span v-else class="grey-500 text-sm">-</span>
    </div>
    <div class="tender-row_actions">
      <InfoTooltip>
        <div class="spacey-12">
          <div>
            <span class="text-bsb">{{ $t('Description') }}</span>
            {{ tender.description }}
          </div>
          <div>
            <span class="text-bsb">{{ $t('Last updated') }}</span> –
            {{ prettyDates(tender.updated_at, true) }}
          </div>
          <div>
            <span class="text-bsb">{{ $t('Construction beginning date') }}</span> –
            {{ prettyDates(tender.created_at) }}
          </div>
        </div>
      </InfoTooltip>
      <v-menu left offset-y transition="slide-y-transition">
        <template v-slot:activator="{ on, attrs }">
          <button v-bind="attrs" class="no-outline flex-centering" v-on="on">
            <HorizontalDotsIcon class="pointer" />
          </button>
        </template>
        <div class="dropdown-body">
          <DropdownMenuElement @click="$emit('invite')">
            {{ $t('Invite new company') }}
            <template slot="icon">
              <PlusIcon />
            </template>
          </DropdownMenuElement>
          <DropdownMenuElement
            text-class="danger-600"
            @click="$emit(isTenderActive ? 'archive' : 'unarchive')"
          >
            {{ isTenderActive ? $t('Archive tender') : $t('Unarchive tender') }}
            <template #icon>
              <CloseIcon class="icon-d-600" />
            </template>
          </DropdownMenuElement>
        </div>
      </v-menu>
    </div>
  </div>
</template>

<script>
  import UserInfo from '@/components/ui/UserInfo';
  import Badge from '@/components/ui/Badge';
  import AttachIcon from '@/assets/icons/paperclip.svg';
  import HorizontalDotsIcon from '@/assets/icons/horizontal-dots.svg';
  import DropdownMenuElement from '@/components/ui/dropdown-menu/DropdownMenuElement';
  import CloseIcon from '@/assets/icons/x.svg';
  import InfoTooltip from '@/components/ui/InfoTooltip';
  import { VMenu } from 'vuetify/lib';
  import prettyDates from '@/utils/formatting/pretty-date';
  import PlusIcon from '@/assets/icons/plus.svg';
  import { mapState } from 'vuex';

  export default {
    name: 'TenderRow',
    components: {
      UserInfo,
      Badge,
      AttachIcon,
      HorizontalDotsIcon,
      VMenu,
      DropdownMenuElement,
      CloseIcon,
      InfoTooltip,
      PlusIcon,
    },
    props: {
      tender: {
        type: Object,
        required: true,
      },
    },
    computed: {
      ...mapState('global', ['tenderStatuses']),
      isTenderActive() {
        return this.tender.status === this.tenderStatuses.active;
      },
    },
    methods: {
      prettyDates,
    },
  };
</script>
